module.exports = __webpack_public_path__ + "static/img/bg_cooppartner1.cce5256.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/detail/bg_cooppartner1.jpg
// module id = 3R+r
// module chunks = 0